import type { StaticAdFilters } from '@/api/routes/static-stat/types';

export const statStaticAdFilters: StaticAdFilters = {
  org: [],
  adv: [],
};
